import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

const LanguageSwitcher = () => {
  const { setLanguage } = useTranslation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const location = useLocation();

  const changeLanguage = (newLang) => {
    setLanguage(newLang);
    const newPath = location.pathname.replace(`/${lang}`, `/${newLang}`);
    navigate(newPath);
  };

  return (
    <div className="flex gap-2 items-center">
      <button
        onClick={() => changeLanguage('en')}
        disabled={lang === 'en'}
        className={` ${lang === 'en' ? ' text-black' : ' text-black/50'}`}
      >
        EN
      </button>
      <button
        onClick={() => changeLanguage('ka')}
        disabled={lang === 'ka'}
        className={` ${lang === 'ka' ? ' text-black' : 'text-black/50'}`}
      >
        KA
      </button>
    </div>
  );
};

export default LanguageSwitcher;